import { useMemo } from "react"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import { Dialog, DialogContent, DialogBody } from "~/react/ui/dialog"
import { useDialog } from "~/react/hooks/useDialog"
import { ModalContent, ModalContentWithoutStripe } from "./modal_content"
import type { AddEmailAccountSlotsModalProps } from "./constants"

export { type AddEmailAccountSlotsModalProps } from "./constants"

export function AddEmailAccountSlotsModal({
  isOpen,
  onClose,
  currentEmailAccountsCount,
  currentMaxEmailAccounts,
  absoluteMaxEmailAccounts,
  planIncludedEmailAccounts,
  pricePerSlot,
  currencySymbol,
  currencyFormat,
  billingCycle,
  subscriptionLevel,
  creditCardInfo,
  nextBillingDate,
  billingPeriodStart,
  stripePublicKey,
  billingInfo,
  userEmail,
  cardholderName: initialCardholderName,
}: AddEmailAccountSlotsModalProps) {
  const { dialogRef, handleBackdropClick, stopPropagation } = useDialog({
    isOpen,
    onClose,
  })

  // Initialize Stripe promise once
  const stripePromise = useMemo(() => {
    if (!stripePublicKey) return null
    return loadStripe(stripePublicKey)
  }, [stripePublicKey])

  if (!isOpen) {
    return null
  }

  const modalContentProps = {
    onClose,
    currentEmailAccountsCount,
    currentMaxEmailAccounts,
    absoluteMaxEmailAccounts,
    planIncludedEmailAccounts,
    pricePerSlot,
    currencySymbol,
    currencyFormat,
    billingCycle,
    subscriptionLevel,
    creditCardInfo,
    nextBillingDate,
    billingPeriodStart,
    billingInfo,
    userEmail,
    initialCardholderName,
    dialogRef,
  }

  return (
    <Dialog
      ref={dialogRef}
      id="add-email-account-slots-modal"
      onClick={handleBackdropClick}
      onPointerDown={stopPropagation}
      onMouseDown={stopPropagation}
    >
      <DialogContent>
        <DialogBody className="p-0">
          {stripePromise ? (
            <Elements stripe={stripePromise}>
              <ModalContent {...modalContentProps} />
            </Elements>
          ) : (
            <ModalContentWithoutStripe {...modalContentProps} />
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default AddEmailAccountSlotsModal
